import { CENTER } from "@/data";
import { Heart, MapPin, Phone, Mail } from "lucide-react";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 px-5 md:px-10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex items-center justify-center w-10 h-10 rounded-2xl bg-sky-400 text-white">
              <Heart className="w-5 h-5 fill-white" />
            </span>
            <span className="font-extrabold text-lg text-white leading-tight">
              Blessed Beginnings
              <span className="block text-[11px] font-semibold text-sky-400 -mt-0.5">
                Learning Center
              </span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-xs">
            {CENTER.tagline} providing safe, reliable, and joyful childcare in Cincinnati, Ohio.
          </p>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            {["home", "about", "programs", "gallery", "contact"].map((id) => (
              <li key={id}>
                <button
                  data-testid={`footer-${id}-link`}
                  onClick={() => scrollTo(id)}
                  className="capitalize hover:text-sky-400 transition-colors"
                >
                  {id}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-sky-400 shrink-0 mt-0.5" />
              <span>{CENTER.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-5 h-5 text-sky-400 shrink-0" />
              <span className="flex flex-col">
                {CENTER.phones.map((p) => (
                  <a
                    key={p}
                    data-testid={`footer-phone-${p}`}
                    href={`tel:${p.replace(/-/g, "")}`}
                    className="hover:text-sky-400 transition-colors"
                  >
                    {p}
                  </a>
                ))}
              </span>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-sky-400 shrink-0" />
              <a
                data-testid="footer-email-link"
                href={`mailto:${CENTER.email}`}
                className="hover:text-sky-400 transition-colors break-all"
              >
                {CENTER.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-slate-800 text-center text-sm text-slate-500">
        © {new Date().getFullYear()} {CENTER.name}. All rights reserved.
      </div>
    </footer>
  );
}
